import { Capacitor } from '@capacitor/core';

/**
 * Open an external URL. In the native Capacitor shell this uses an in-app
 * browser (SFSafariViewController / Chrome Custom Tabs via @capacitor/browser)
 * so the user stays inside the app; on web it opens a new tab.
 *
 * The @capacitor/browser plugin is accessed via the runtime `Capacitor.Plugins`
 * registry (no import) so the web build never requires it. Install
 * `@capacitor/browser` + `npx cap sync` to enable the in-app browser on native;
 * until then (and always on web) we fall back to window.open.
 */
export async function openExternal(url: string): Promise<void> {
  if (Capacitor.isNativePlatform()) {
    const Browser = (
      Capacitor as unknown as {
        Plugins?: Record<
          string,
          { open?: (opts: { url: string; presentationStyle?: string }) => Promise<void> }
        >;
      }
    ).Plugins?.Browser;
    if (Browser?.open) {
      try {
        await Browser.open({ url, presentationStyle: 'popover' });
        return;
      } catch {
        // fall through to window.open
      }
    }
  }
  window.open(url, '_blank', 'noopener,noreferrer');
}
